import { app } from "api";
import { getTime, set, parseISO } from "date-fns";
import { QueryKey, useQuery } from "react-query";

export function useTransactions(key: QueryKey) {
  const uid = app.auth().currentUser?.uid;

  return useQuery(key, async (key: string, { start, end }: any) => {
    return (
      await app
        .firestore()
        .collectionGroup("labTransactions")
        .where("labId", "==", uid)
        .where("status", "==", "confirmed")
        .where(
          "createdAt",
          ">=",
          getTime(set(parseISO(start), { hours: 0, minutes: 0, seconds: 0 }))
        )
        .where(
          "createdAt",
          "<",
          getTime(set(parseISO(end), { hours: 23, minutes: 59, seconds: 59 }))
        )
        .orderBy("createdAt", "asc")
        .get()
    ).docs.map((i) => i.data());
  });
}
